import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { TenantPaymentFormData } from "@/formTypes/TenantPaymentDataType";

export type TenantPaymentDataType = Partial<ApiSchema["TenantPayment"]["type"] & TenantPaymentFormData>;
class Api extends GenericModelApi<"TenantPayment", TenantPaymentDataType> {

}
export const TenantPaymentApi = new Api("TenantPayment", "createdAt", "DESC");